import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'right-side',
  templateUrl: './right-side.component.html',
  styleUrls: ['./right-side.component.css']
})
export class RightSideComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
